// import 'hammerjs';
import { enableProdMode, ApplicationRef } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { enableDebugTools } from '@angular/platform-browser';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .then(module => {
    if (!environment.production) {
      enableDebugTools(module.injector.get(ApplicationRef).components[0]); // run ng.profiler.timeChangeDetection() in the console window. Change detection should be lower than 16ms
    }
  })
  .catch(err => console.error(err));
